import { Facebook, Twitter, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ title }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const open = (href) => window.open(href, "_blank", "noopener,width=600,height=500");

  const nativeShare = async () => {
    try {
      await navigator.share({ title, url });
    } catch { /* user cancelled */ }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy — copy the address bar URL instead");
    }
  };

  const btn = "p-2 border border-black/15 text-black/60 hover:text-white hover:bg-[#4A5D23] hover:border-[#4A5D23] transition-colors duration-150";

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="text-[10px] font-bold uppercase tracking-widest text-black/40 mr-1">Share</span>
      <button data-testid="share-facebook" aria-label="Share on Facebook" onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)} className={btn}><Facebook size={14} /></button>
      <button data-testid="share-x" aria-label="Share on X" onClick={() => open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`)} className={btn}><Twitter size={14} /></button>
      <button data-testid="share-copy" aria-label="Copy link" onClick={copyLink} className={btn}><Link2 size={14} /></button>
      {typeof navigator !== "undefined" && !!navigator.share && (
        <button data-testid="share-native" aria-label="Share" onClick={nativeShare} className={btn}><Share2 size={14} /></button>
      )}
    </div>
  );
};
